import { Fragment, useEffect, useState } from 'react';
import Spinner from '../../../components/spinner/Spinner';
import { GetReportSettings, GetSalesCompanyDetails, GetSalesCompanyTaskDetails } from '../../../Services';
import { useParams } from 'react-router-dom';
import GridMapV5 from '../../../components/gridReport/v5/gridMap/GridMapV5';
import './AuditReportPublicView_OLD_V1.css';
import moment from 'moment';
import {
	GetNormalizedReportDataByCompanyId,
	GetNormalizedReportDataByTaskIdFromDb,
	GetReportAnalizedSummaryData
} from '../../../ReportAPI';
import { getHighlightedText, isNumber, capitalize, isMobile } from '../../../utils/Common';
import ModalDialog from '../../../components/modalDialog/ModalDialog';
import ModalDialogContent from '../../../components/modalDialog/modalDialogContent/ModalDialogContent';
import ModalDialogButtons from '../../../components/modalDialog/modalDialogButtons/ModalDialogButtons';

const AuditReportPublicView_OLD_V1 = () => {
	const [ isLoading, setIsLoading ] = useState(true);
	const [ isLoadingMap, setIsLoadingMap ] = useState(false);
	const [ isLoadingAuditData, setIsLoadingAuditData ] = useState(false);
	const [ companyData, setCompanyData ] = useState();
	const [ mapGridData, setMapGridData ] = useState();
	const [ taskGridData, setTaskGridData ] = useState();
	const [ task, setTask ] = useState();
	const { reportId } = useParams();
	const [ gridKeywords, setGridKeywords ] = useState();
	const [ selectedKeyword, setSelectedKeyword ] = useState();
	const [ reportSettings, setReportSettings ] = useState();
	const [ competitorsData, setCompetitorsData ] = useState();
	const [ competitorsDataForAllKeywords, setCompetitorsDataForAllKeywords ] = useState();
	const [ competitorsDataForCopy, setCompetitorsDataForCopy ] = useState();
	const [ showCompetitorsPanel, setShowCompetitorsPanel ] = useState(false);
	const [ selectedCompetitorOnMap, setSelectedCompetitorOnMap ] = useState();
	const [ auditResponseData, setAuditResponseData ] = useState();
	const [ auditKeywordData, setAuditKeywordData ] = useState();
	const [ showJsonOutputDialog, setShowJsonOutputDialog ] = useState(false);
	const [ jsonOutput, setJsonOutput ] = useState();
	const [ summaryData, setSuummaryData ] = useState();
	const [ summaryChecklistItems, setSummaryChecklistItems ] = useState();
	const [ summaryChecklistItemsByKeyword, setSummaryChecklistItemsByKeyword ] = useState();
	const [ summaryCompetitionItems, setSummaryCompetitionItems ] = useState();
	const [ summaryCompetitionItemsByKeyword, setSummaryCompetitionItemsByKeyword ] = useState();
	const [ businessGridAverageData, setBusinessGridAverageData ] = useState();
	const [ businessGridAverageDataByKeyword, setBusinessGridAverageDataByKeyword ] = useState();

	const settings = [
		{ label: 'Categories', propName: 'categories', printPropName: 'profile.categories', checkboxName: 'Profile' },
		{ label: 'Address', propName: 'address', printPropName: 'profile.address' },
		{ label: 'Phone Number', propName: 'phoneNumber', printPropName: 'profile.phone' },
		{ label: 'Website URL', propName: 'websiteUrl', printPropName: 'profile.website' },
		{ label: 'Contact URL', propName: 'contactUrl', printPropName: 'profile.contactUrl' },
		{ label: 'Description', propName: 'description', printPropName: 'profile.description', shouldTruncate: false },
		{ label: 'Business Hours', propName: 'businessHours', printPropName: 'workTime' },
		{ label: 'Total Reviews', propName: 'totalReviews', printPropName: 'reviews' },
		{ label: 'Total Posts', propName: 'totalPosts', printPropName: 'posts', checkboxName: 'TotalPosts' },
		{ label: 'Total Q&A', propName: 'totalQA', printPropName: 'qa', checkboxName: 'TotalQA' },
		{ label: 'Total Images', propName: 'totalPhotos' },
		{ label: 'Logo', propName: 'logo', printPropName: 'profile.logo' },
		{ label: 'Main Image', propName: 'mainImage', printPropName: 'profile.mainImage' },
		{ label: 'Social Profiles', propName: 'socialProfiles', printPropName: 'profile.socialProfiles' }
	];
	const kwSettings = [
		{
			label         : 'Profile Categories',
			propName      : 'keywordInCategories',
			printPropName : 'profile.categories',
			hoverPropName : 'occurrencesInCategories',
			highlightText : true
		},
		{
			label         : 'Profile Title',
			propName      : 'keywordInTitle',
			printPropName : 'profile.title',
			hoverPropName : 'occurrencesInTitle',
			highlightText : true
		},
		{
			label          : 'Profile Description',
			propName       : 'keywordInDescription',
			printPropName  : 'profile.description',
			hoverPropName  : 'occurrencesInDescription',
			shouldTruncate : false,
			highlightText  : true
		},
		{
			label         : 'Profile Reviews (Last 20)',
			propName      : 'keywordInReviews',
			printPropName : 'reviews.last20',
			hoverPropName : 'occurrencesInReviews',
			checkboxName  : 'TotalReviews',
			highlightText : true
		},
		{
			label         : 'Profile Posts',
			propName      : 'keywordInPosts',
			printPropName : 'posts',
			hoverPropName : 'occurrencesInPosts',
			checkboxName  : 'TotalPosts',
			highlightText : true
		},
		{
			label         : 'Profile Q&A',
			propName      : 'keywordInQA',
			printPropName : 'qa',
			hoverPropName : 'occurrencesInQA',
			checkboxName  : 'TotalQA',
			highlightText : true
		},
		{
			label         : 'Website Landing Page',
			propName      : 'keywordInWebsiteLandingPage',
			printPropName : 'occurrencesInHtml',
			hoverPropName : 'occurrencesInHtml',
			checkboxName  : 'WebsiteLandingPage',
			highlightText : true
		},
		{
			label         : 'Website Pages Indexed',
			propName      : 'keywordWebsitePagesIndexed',
			printPropName : 'indexedPagesByKeyword.results',
			hoverPropName : 'occurrencesInIndexedPages',
			checkboxName  : 'KeywordDensityOnIndexedPages'
			// highlightText : true
		}
	];
	const reviewsLast20Settings = [
		{ label: 'Average Rating', propName: 'last20AverageRating' },
		{ label: 'Average Words Per Review', propName: 'last20AverageWordsPerReview' },
		{ label: 'Have Replies', propName: 'last20HaveReplies' },
		{ label: 'Local Guide Reviews', propName: 'last20LocalGuideReviews' },
		{ label: 'Negative Reviews', propName: 'last20NegativeReviews' },
		{ label: 'Negative Reviews Have Replies', propName: 'last20NegativeReviewsHaveReplies' }
	];
	const reviewsLast30DaysSettings = [
		{ label: 'Total Reviews', propName: 'last30TotalReviews' },
		{ label: 'Average Rating', propName: 'last30AverageRating' },
		{ label: 'Average Words Per Review', propName: 'last30AverageWordsPerReview' },
		{ label: 'Have Replies', propName: 'last30HaveReplies' },
		{ label: 'Local Guide Reviews', propName: 'last30LocalGuideReviews' },
		{ label: 'Negative Reviews', propName: 'last30NegativeReviews' },
		{ label: 'Negative Reviews Have Replies', propName: 'last30NegativeReviewsHaveReplies' }
	];

	useEffect(() => {
		getReportSettings();
	}, []);

	//get task details
	useEffect(
		() => {
			if (reportId) {
				getSalesCompanyTask();
			}
		},
		[ reportId ]
	);

	//mapReady event
	useEffect(
		() => {
			if (window.mapReady) {
				setIsLoadingMap(false);
			}
		},
		[ window.mapReady ]
	);

	const getReportSettings = async () => {
		let response = await GetReportSettings();

		if (response && response.data) {
			setReportSettings(response.data);
		}
	};

	const getCompanyDetails = async (id) => {
		let response = await GetSalesCompanyDetails(id);

		if (response) {
			setCompanyData(response);
		}
	};

	const getSalesCompanyTask = async () => {
		const response = await GetSalesCompanyTaskDetails(reportId);

		if (response) {
			setTask(response);

			if (response.salesCompanyId) {
				await getCompanyDetails(response.salesCompanyId);
			}

			//parse grid data
			if (response.content) {
				let gridReportData = JSON.parse(response.content);

				if (gridReportData) {
					setTaskGridData(gridReportData);

					setMapGridData({
						googlePlaceId    : gridReportData.googlePlaceId,
						lat              : response.lat,
						lng              : response.lng,
						horizontalPoints : response.gridPoints,
						verticalPoints   : response.gridPoints,
						...(gridReportData.gridResponse && gridReportData.gridResponse.data
							? gridReportData.gridResponse.data[0]
							: null)
					});

					if (gridReportData.gridResponse && gridReportData.gridResponse.data) {
						let tempKeywords = gridReportData.gridResponse.data.map((x) => x.keyword);

						setGridKeywords(tempKeywords);

						if (tempKeywords && tempKeywords.length) {
							setSelectedKeyword(tempKeywords[0]);
						}
					}
				}
			}
		}

		setIsLoadingMap(false);
		setIsLoading(false);
	};

	const getCompetitorsData = async (gridData, currentKeyword) => {
		if (gridData && gridData.gridResponse && gridData.gridResponse.data) {
			let tempCompetitorsDataForAllKeywords = [];
			let tempBusinessGridAverageData = [];

			gridData.gridResponse.data.forEach((keywordGridData) => {
				let tempCompetitorsData = [];
				let tempBusinessPositionTotal = 0;

				//we need to attach opposite rankings in order to find most top rankings
				//i.e for ranking 1 we set 21, for 2 is 20..... for 21 is 0, so it's (21-position)
				if (keywordGridData && keywordGridData.points && keywordGridData.points.length) {
					keywordGridData.points.forEach((point) => {
						if (point.results && point.results.length) {
							//calculate average grid ranking for business
							let businessItem = point.results.find((x) => x.place_id === companyData.googlePlaceId);
							if (businessItem) {
								tempBusinessPositionTotal += businessItem.position;
							} else {
								tempBusinessPositionTotal += 21;
							}

							//first get all distinct competitors
							point.results.forEach((pointResult) => {
								//skip current company results
								if (
									pointResult.place_id !== companyData.googlePlaceId &&
									!tempCompetitorsData.some((comp) => comp.place_id === pointResult.place_id)
								) {
									pointResult.top3Count = 0;
									pointResult.positionTotal = 0;
									tempCompetitorsData.push(pointResult);
								}
							});
						}
					});

					//get top3 and total sum of position rankings for each competitor
					tempCompetitorsData.forEach((comp) => {
						keywordGridData.points.forEach((point) => {
							if (point.results && point.results.length) {
								let compPointResult = point.results.find((x) => x.place_id === comp.place_id);

								let rankingPosition = compPointResult ? compPointResult.position : 21;

								comp.positionTotal += rankingPosition;

								if (rankingPosition > 0 && rankingPosition < 4) {
									comp.top3Count++;
								}
							}
						});
					});
				}

				let pointsNumber = keywordGridData.points.length;

				tempBusinessGridAverageData.push({
					keyword : keywordGridData.keyword,
					average : parseFloat(tempBusinessPositionTotal / pointsNumber).toFixed(1)
				});
				setBusinessGridAverageData(tempBusinessGridAverageData);

				//calculate average ranking
				tempCompetitorsData.forEach((comp) => {
					comp.average = parseFloat(comp.positionTotal / pointsNumber).toFixed(1);
				});

				tempCompetitorsData = tempCompetitorsData.sort((a, b) => b.top3Count - a.top3Count);

				tempCompetitorsDataForAllKeywords.push({
					keyword         : keywordGridData.keyword,
					competitorsData : tempCompetitorsData
				});

				//set states for current keyword
				if (keywordGridData.keyword === currentKeyword) {
					setCompetitorsData(tempCompetitorsData);

					let tempCompetitorsDataCopyString = '';

					tempCompetitorsData.forEach((competitor, index) => {
						if (competitor.top3Count && competitor.top3Count > 0) {
							tempCompetitorsDataCopyString += `${competitor.title} (${competitor.top3Count}), ${competitor.place_id}, ${competitor.data_cid}, ${competitor.website}\r\n`;
						}
					});

					setCompetitorsDataForCopy(tempCompetitorsDataCopyString);
				}
			});

			setCompetitorsDataForAllKeywords(tempCompetitorsDataForAllKeywords);

			//set business grid average by keyword
			if (selectedKeyword && tempBusinessGridAverageData && tempBusinessGridAverageData.length) {
				let tempBusinessGridAverageDataByKeyword = tempBusinessGridAverageData.find(
					(x) => x.keyword === selectedKeyword
				);
				if (tempBusinessGridAverageDataByKeyword) {
					setBusinessGridAverageDataByKeyword(tempBusinessGridAverageDataByKeyword.average);
				}
			}
		}
	};

	const getNormalizedReportData = async (id, reportName) => {
		setIsLoadingAuditData(true);

		let response = await GetNormalizedReportDataByCompanyId(id, reportName);

		if (response.success) {
			setAuditResponseData(response.data);
		} else {
			setAuditResponseData();
		}

		setIsLoadingAuditData(false);
	};

	const getNormalizedReportDataFromDb = async (taskId) => {
		setIsLoadingAuditData(true);

		let response = await GetNormalizedReportDataByTaskIdFromDb(taskId);

		if (response.success) {
			if (response.data && response.data.length) {
				setAuditResponseData(response.data);
			}
		}

		setIsLoadingAuditData(false);
	};

	const getReportAnalizedSummaryData = async (reportName) => {
		let response = await GetReportAnalizedSummaryData(task.salesCompanyId, reportName);
		if (response.success && response.keywords) {
			setSuummaryData(response.keywords);
		} else {
			setSuummaryData();
		}
	};

	//get competitors data
	useEffect(
		() => {
			if (companyData && taskGridData) {
				getCompetitorsData(taskGridData, selectedKeyword);
				getReportAnalizedSummaryData(task.id);
			}
		},
		[ companyData, taskGridData ]
	);

	//get audit data
	useEffect(
		() => {
			if (task) {
				// getNormalizedReportDataFromDb(task.id);
				getNormalizedReportData(task.salesCompanyId, task.id);
			}
		},
		[ task ]
	);

	//audit response data
	useEffect(
		() => {
			if (auditResponseData) {
				let tempAuditResponseData = [ ...auditResponseData ];

				//get data for selected keyword
				let tempAuditResponseKwData = tempAuditResponseData.find((x) => x.keyword === selectedKeyword);

				if (tempAuditResponseKwData) {
					//build business and competitors data as array items to display data easier
					let tempAuditKeywordData = [];
					tempAuditKeywordData.push(tempAuditResponseKwData.businessData);

					if (tempAuditResponseKwData.competitorsData && tempAuditResponseKwData.competitorsData.length > 0) {
						tempAuditResponseKwData.competitorsData.map((comp) => {
							tempAuditKeywordData.push(comp);
						});
					}

					//set minimal timeout to see the spinner
					setIsLoadingAuditData(true);
					setTimeout(function() {
						setAuditKeywordData(tempAuditKeywordData);
						setIsLoadingAuditData(false);
					}, 300);
				}
			}
		},
		[ auditResponseData, selectedKeyword ]
	);

	//analyzed summary data
	useEffect(
		() => {
			if (summaryData && summaryData.length > 0) {
				//common checklist items
				let tempChecklistItems = summaryData[0].messages.filter(
					(x) => x.type === 'Checklist' && !x.field.toLowerCase().startsWith('keyword')
				);
				setSummaryChecklistItems(tempChecklistItems);

				//common competition items
				let tempCompetitionItems = summaryData[0].messages.filter(
					(x) => x.type === 'Competition' && !x.field.toLowerCase().startsWith('keyword')
				);
				setSummaryCompetitionItems(tempCompetitionItems);

				if (selectedKeyword) {
					let kwAnalyzedData = summaryData.find((x) => x.keyword === selectedKeyword);

					if (kwAnalyzedData && kwAnalyzedData.messages) {
						let tempChecklistItemsByKeyword = kwAnalyzedData.messages.filter(
							(x) => x.type === 'Checklist' && x.field.toLowerCase().startsWith('keyword')
						);
						setSummaryChecklistItemsByKeyword(tempChecklistItemsByKeyword);

						let tempCompetitionItemsByKeyword = kwAnalyzedData.messages.filter(
							(x) => x.type === 'Competition' && x.field.toLowerCase().startsWith('keyword')
						);
						setSummaryCompetitionItemsByKeyword(tempCompetitionItemsByKeyword);
					}
				}
			}
		},
		[ summaryData ]
	);

	const handleSelectKeyword = (keywordName) => {
		setSelectedKeyword(keywordName);
	};

	//handle selected keyword
	useEffect(
		() => {
			if (selectedKeyword && taskGridData) {
				let tempSelectedTaskGridData = { ...taskGridData };

				let tempGridData = tempSelectedTaskGridData.gridResponse.data.filter(
					(k) => k.keyword.trim().toLowerCase() === selectedKeyword.trim().toLowerCase()
				);

				setMapGridData({
					googlePlaceId    : tempSelectedTaskGridData.googlePlaceId,
					lat              : tempSelectedTaskGridData.gridResponse.lat,
					lng              : tempSelectedTaskGridData.gridResponse.lng,
					horizontalPoints : tempSelectedTaskGridData.gridResponse.horizontalPoints,
					verticalPoints   : tempSelectedTaskGridData.gridResponse.verticalPoints,
					...(tempGridData && tempGridData.length ? tempGridData[0] : null)
				});

				getCompetitorsData(taskGridData, selectedKeyword);
				getReportAnalizedSummaryData(task.id);

				//set business grid average
				if (businessGridAverageData && businessGridAverageData.length) {
					let tempBusinessGridAverageDataByKeyword = businessGridAverageData.find(
						(x) => x.keyword === selectedKeyword
					);
					if (tempBusinessGridAverageDataByKeyword) {
						setBusinessGridAverageDataByKeyword(tempBusinessGridAverageDataByKeyword.average);
					}
				}

				setSelectedCompetitorOnMap();
			}
		},
		[ selectedKeyword ]
	);

	const toggleCompetitorsPanel = () => {
		setShowCompetitorsPanel(!showCompetitorsPanel);

		if (showCompetitorsPanel) {
			setSelectedCompetitorOnMap();
		}
	};

	const handleSelectCompetitorOnMap = (competitor) => {
		setSelectedCompetitorOnMap(competitor);
	};

	const handleSelectCompetitorOnMapMobile = (competitorPlaceId) => {
		if (competitorsData) {
			setSelectedCompetitorOnMap(competitorsData.find((x) => x.place_id === competitorPlaceId));
		}
	};

	const printJsonNodeValue = (dataIndex, setting) => {
		let output = '';

		let propName = setting.propName;
		let printPropName = setting.printPropName;
		let label = setting.label;
		let shouldTruncate = setting.shouldTruncate;
		let shouldHighlightText = setting.highlightText;

		if (auditKeywordData) {
			if (propName === 'socialProfiles') {
				printSocialProfilesList(dataIndex);
				return;
			} else if (propName === 'totalPhotos') {
				//don't open print dialog
				return;
			} else if (printPropName) {
				if (printPropName === 'reviews') {
					printReviewsList(dataIndex, 'total', shouldHighlightText);
					return;
				} else if (printPropName === 'reviews.last20') {
					printReviewsList(dataIndex, 'last20', null, shouldHighlightText);
					return;
				} else if (printPropName === 'workTime') {
					printWorkHours(dataIndex);
					return;
				} else if (printPropName === 'posts') {
					printPostsList(dataIndex, shouldHighlightText);
					return;
				} else if (printPropName === 'qa') {
					printQAList(dataIndex, shouldHighlightText);
					return;
				} else if (
					printPropName.indexOf('citations') > -1 ||
					printPropName.indexOf('powerCitations') > -1 ||
					printPropName.indexOf('powerContent') > -1 ||
					printPropName.indexOf('indexedPages') > -1
				) {
					printCitationsList(dataIndex, printPropName, shouldHighlightText);
					return;
				}
			}

			let foundNodeValue;
			let prinPropNameArgs = [];

			if (printPropName) {
				prinPropNameArgs = printPropName.indexOf('.') > -1 ? printPropName.split('.') : [ printPropName ];
			}

			if (prinPropNameArgs && prinPropNameArgs.length === 1) {
				foundNodeValue = auditKeywordData[dataIndex][prinPropNameArgs[0]];
			} else if (prinPropNameArgs && prinPropNameArgs.length === 2) {
				foundNodeValue = auditKeywordData[dataIndex][prinPropNameArgs[0]][prinPropNameArgs[1]];
			} else if (prinPropNameArgs && prinPropNameArgs.length === 3) {
				foundNodeValue =
					auditKeywordData[dataIndex][prinPropNameArgs[0]][prinPropNameArgs[1]][prinPropNameArgs[2]];
			}

			if (label) {
				output += `<h4 class="json-output-title mb-3">${label}</h4>`;
			}

			if (foundNodeValue) {
				if (Array.isArray(foundNodeValue)) {
					foundNodeValue.map((value, index) => {
						if (typeof value === 'object') {
							output +=
								'<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';
							output += outputObjectAsHtml(value, index, 0, shouldTruncate);
							output += '</div>';
						} else {
							output += outputValueAsHtml(value, index, shouldTruncate, shouldHighlightText);
						}
					});
				} else if (typeof foundNodeValue === 'object') {
					output += outputObjectAsHtml(foundNodeValue, null, 0, shouldTruncate);
				} else {
					output += outputValueAsHtml(foundNodeValue, null, shouldTruncate, shouldHighlightText);
				}
			} else {
				output += '<label class="form-label json-output-object-item-value">No data</label>';
			}
		}

		setJsonOutput(output);
		toggleJsonOutputDialog();

		return output;
	};

	const outputObjectAsHtml = (objectValue, arrayIndex = null, nestingLevel = 0, shouldTruncate = true) => {
		let output = '';

		Object.keys(objectValue).map((key, objectIndex) => {
			let parsedItemValue;

			if (objectValue[key]) {
				if (typeof objectValue[key] === 'object') {
					output += outputObjectAsHtml(objectValue[key], null, nestingLevel++, shouldTruncate);
				} else {
					parsedItemValue = objectValue[key];
				}

				if (parsedItemValue === true) {
					parsedItemValue = 'Yes';
				} else if (parsedItemValue === false) {
					parsedItemValue = 'No';
				}

				let textTruncate = shouldTruncate ? 'text-truncate' : '';

				output += `<div class="col-12 json-output-object-item" key="${objectIndex}">`;
				output += `<label class="form-label json-output-object-item-label" title="${key}"><strong>${arrayIndex !==
					null && objectIndex === 0
					? `<span>${arrayIndex + 1}. </span>`
					: ''}<span>${key}:</span></strong></label>`;

				if (typeof parsedItemValue === 'string') {
					if (parsedItemValue.indexOf('https://') > -1 || parsedItemValue.indexOf('http://') > -1) {
						output += `<a class="btn btn-link p-0 json-output-object-item-value ${textTruncate}" title="${parsedItemValue}" target="_blank" href="${parsedItemValue}">${parsedItemValue}</a>`;
					} else {
						output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${parsedItemValue}">${parsedItemValue}</label>`;
					}
				} else {
					if (typeof parsedItemValue === 'object') {
						output += `<div class="form-label json-output-object-item-value ${textTruncate}" title="${parsedItemValue}" dangerouslySetInnerHTML="${parsedItemValue}"></div>`;
					} else {
						output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${parsedItemValue}">${parsedItemValue}</label>`;
					}
				}

				output += `</div>`;
			}
		});

		return output;
	};

	const outputValueAsHtml = (value, arrayIndex = null, shouldTruncate = true, shouldHighlightText = false) => {
		let output = '';
		let ordinal = arrayIndex !== null ? `<span>${arrayIndex + 1}. </span>` : '';
		let textTruncate = shouldTruncate ? 'text-truncate' : '';
		let titleValue = value;

		if (shouldHighlightText && selectedKeyword) {
			value = getHighlightedText(value, selectedKeyword);
		}

		if (typeof value === 'string') {
			if (value.indexOf('https://') > -1 || value.indexOf('http://') > -1) {
				output += `<a class="btn btn-link py-0 json-output-object-item-value ${textTruncate}" title="${titleValue}" target="_blank" href="${value}">${ordinal}${value}</a>`;
			} else {
				output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${titleValue}">${ordinal}${value}</label>`;
			}
		} else {
			output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${titleValue}">${ordinal}${value}</label>`;
		}

		return output;
	};

	const printReviewsList = (dataIndex, reviewsType, subType = null, shouldHighlightText = false) => {
		let output = '';

		let reviewsTitle = 'Reviews';

		switch (reviewsType) {
			case 'last30Days':
				reviewsTitle = 'Reviews in the last 30 days';
				break;
			case 'last20':
				reviewsTitle = 'Last 20 Reviews';
				break;
			case 'mostRelevant':
				reviewsTitle = 'Most Relevant Reviews';
				break;
			case 'total':
				reviewsTitle = 'Reviews';
				break;
		}

		output += `<h4 class="json-output-title mb-3">${reviewsTitle}</h4>`;

		if (auditKeywordData && auditKeywordData[dataIndex] && auditKeywordData[dataIndex].reviews) {
			let reviews;

			if (reviewsType === 'total') {
				//merge last 20. last 30 days and most relevant reviews
				let reviewsLast30Days = [];
				let reviewsLast20 = [];
				let reviewsMostRelevant = [];

				if (
					auditKeywordData[dataIndex].reviews.last30Days &&
					auditKeywordData[dataIndex].reviews.last30Days.results
				) {
					reviewsLast30Days = auditKeywordData[dataIndex].reviews.last30Days.results;
				}

				if (auditKeywordData[dataIndex].reviews.last20 && auditKeywordData[dataIndex].reviews.last20.results) {
					reviewsLast20 = auditKeywordData[dataIndex].reviews.last20.results;
				}

				if (
					auditKeywordData[dataIndex].reviews.mostRelevant &&
					auditKeywordData[dataIndex].reviews.mostRelevant.results
				) {
					reviewsMostRelevant = auditKeywordData[dataIndex].reviews.mostRelevant.results;
				}

				let tempMergedReviews = reviewsLast30Days.concat(
					reviewsLast20.filter(
						(item2) => !reviewsLast30Days.some((item1) => item1.reviewId === item2.reviewId)
					)
				);

				reviews = tempMergedReviews.concat(
					reviewsMostRelevant.filter(
						(item2) => !tempMergedReviews.some((item1) => item1.reviewId === item2.reviewId)
					)
				);
			} else {
				reviews = auditKeywordData[dataIndex].reviews[reviewsType].results;
			}

			if (reviews && reviews.length > 0) {
				//filter by subtype
				if (subType) {
					if (reviewsType === 'last30Days') {
						switch (subType) {
							case 'last30HaveReplies':
								reviews = reviews.filter((x) => x.answer !== null);
								break;
							case 'last30LocalGuideReviews':
								reviews = reviews.filter((x) => x.user !== null && x.user.localGuide === true);
								break;
							case 'last30NegativeReviews':
								reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3);
								break;
							case 'last30NegativeReviewsHaveReplies':
								reviews = reviews.filter(
									(x) => x.rating !== null && x.rating <= 3 && x.answer !== null
								);
								break;
						}
					} else if (reviewsType === 'last20') {
						switch (subType) {
							case 'last20HaveReplies':
								reviews = reviews.filter((x) => x.answer !== null);
								break;
							case 'last20LocalGuideReviews':
								reviews = reviews.filter((x) => x.user !== null && x.user.localGuide === true);
								break;
							case 'last20NegativeReviews':
								reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3);
								break;
							case 'last20NegativeReviewsHaveReplies':
								reviews = reviews.filter(
									(x) => x.rating !== null && x.rating <= 3 && x.answer !== null
								);
								break;
						}
					}
				}

				reviews.map((review, index) => {
					if (typeof review === 'object') {
						output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

						//user
						if (review.user && review.user.name) {
							output += `<div class="form-label json-output-object-item-value text-truncate" title="${review
								.user.name}"><strong><span>${index + 1}. </span></strong>${review.user.name}`;

							if (review.user.localGuide === true) {
								output += `<span class="ms-3">(local guide)</span>`;
							}
							output += '</div>';
						}

						//rating
						if (review.rating && parseInt(review.rating)) {
							let ratingStarsHtml = '';
							let rating = parseInt(review.rating);
							for (let i = 0; i < rating; i++) {
								ratingStarsHtml += `<i class="fa-solid fa-star me-1"></i>`;
							}

							if (rating < 5) {
								for (let i = rating; i < 5; i++) {
									ratingStarsHtml += `<i class="fa-regular fa-star text-muted opacity-50 me-1"></i>`;
								}
							}

							output += `<div class="form-label json-output-object-item-value text-truncate small-size mb-2">${ratingStarsHtml}`;

							//date
							if (review.lastEditOfDate) {
								output += `<span class="ms-3">${`${moment(review.lastEditOfDate).format(
									'DD-MM-YYYY'
								)} (${review.dateString})`}</span>`;
							}

							output += `</div>`;
						}

						//text
						let reviewText = review.text || review.snippet;
						let reviewTextForTitle = reviewText;
						if (reviewText) {
							if (shouldHighlightText && selectedKeyword) {
								reviewText = getHighlightedText(reviewText, selectedKeyword);
							}

							output += `<div class="json-output-object-item">`;
							output += `<label class="form-label json-output-object-item-value text-truncate w-100" title="${reviewTextForTitle}">${reviewText}</label>`;
							output += '</div>';
						}

						//answer
						if (review.answer) {
							let answerText = review.answer.text || review.answer.text;
							let answerTextForTitle = answerText;

							if (shouldHighlightText && selectedKeyword) {
								answerText = getHighlightedText(answerText, selectedKeyword);
							}

							output += `<div class="json-output-object-item">`;
							output += '<div class="review-answer border-start">';
							output += `<label class="form-label json-output-object-item-value text-truncate w-100"><strong>Response:</strong>`;

							//date
							if (review.answer.lastEditOfAnswerDate) {
								output += `<span class="ms-3 small-size">${`${moment(
									review.answer.lastEditOfAnswerDate
								).format('DD-MM-YYYY')} (${review.answer.answerDateString})`}</span>`;
							}
							output += '</label>';

							output += `<label class="form-label json-output-object-item-value text-truncate w-100" title="${answerTextForTitle}">${answerText}</label>`;
							output += '</div>';
							output += '</div>';
						}

						output += '</div>';
					}
				});
			} else {
				output += '<label class="form-label json-output-object-item-value">No data</label>';
			}
		} else {
			output += '<label class="form-label json-output-object-item-value">No data</label>';
		}

		setJsonOutput(output);
		toggleJsonOutputDialog();

		return output;
	};

	const printSocialProfilesList = (dataIndex) => {
		let output = '';

		let title = 'Social Profiles';
		output += `<h4 class="json-output-title mb-3">${title}</h4>`;

		if (
			auditKeywordData &&
			auditKeywordData[dataIndex] &&
			auditKeywordData[dataIndex].profile &&
			auditKeywordData[dataIndex].profile.socialProfiles
		) {
			let items = auditKeywordData[dataIndex].profile.socialProfiles;

			if (items && items.length > 0) {
				items.map((item, index) => {
					output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

					//name
					if (item.name) {
						output += `<div class="form-label json-output-object-item-value text-truncate">`;
						output += `<span>${index + 1}. </span>${item.name}`;
						output += '</div>';
					}

					//link
					if (item.link) {
						output += `<div class="form-label json-output-object-item-value text-truncate">`;
						output += `<a class="btn btn-link p-0 json-output-object-item-value text-truncate" title="${item.link}" href="${item.link}" target="_blank">${item.link}</a>`;
						output += '</div>';
					}

					output += '</div>';
				});
			} else {
				output += '<label class="form-label json-output-object-item-value">No data</label>';
			}
		} else {
			output += '<label class="form-label json-output-object-item-value">No data</label>';
		}

		setJsonOutput(output);
		toggleJsonOutputDialog();

		return output;
	};

	const printPostsList = (dataIndex, shouldHighlightText = false) => {
		let output = '';

		let title = 'Posts';
		output += `<h4 class="json-output-title mb-3">${title}</h4>`;

		if (
			auditKeywordData &&
			auditKeywordData[dataIndex] &&
			auditKeywordData[dataIndex].posts &&
			auditKeywordData[dataIndex].posts.results
		) {
			let items = auditKeywordData[dataIndex].posts.results;

			if (items && items.length > 0) {
				items.map((item, index) => {
					output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

					//author
					if (item.author) {
						output += `<div class="form-label json-output-object-item-value text-truncate">`;
						output += `<span>${index + 1}. </span>${item.author}`;
						output += '</div>';
					}

					//date
					if (item.postDateValue) {
						output += `<div class="form-label json-output-object-item-value small-size text-truncate">`;
						output += `<span>${moment(item.postDateValue).format('DD-MM-YYYY')}`;
						output += '</div>';
					}

					//text
					if (item.postText) {
						let textFortitle = item.postText;

						if (shouldHighlightText && selectedKeyword) {
							item.postText = getHighlightedText(item.postText, selectedKeyword);
						}

						output += `<div class="form-label json-output-object-item-value text-truncate">`;
						output += `<label class="json-output-object-item-value text-truncate" title="${textFortitle}">${item.postText}</label>`;
						output += '</div>';
					}

					output += '</div>';
				});
			} else {
				output += '<label class="form-label json-output-object-item-value">No data</label>';
			}
		} else {
			output += '<label class="form-label json-output-object-item-value">No data</label>';
		}

		setJsonOutput(output);
		toggleJsonOutputDialog();

		return output;
	};

	const printQAList = (dataIndex, shouldHighlightText = false) => {
		let output = '';

		let title = 'Questions & Answers';
		output += `<h4 class="json-output-title mb-3">${title}</h4>`;

		if (
			auditKeywordData &&
			auditKeywordData[dataIndex] &&
			auditKeywordData[dataIndex].qa &&
			auditKeywordData[dataIndex].qa.results
		) {
			let items = auditKeywordData[dataIndex].qa.results;

			if (items && items.length > 0) {
				items.map((item, index) => {
					output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

					//user
					if (item.profileName) {
						output += `<div class="form-label json-output-object-item-value text-truncate" title="${item.profileName}"><span>${index +
							1}. </span>${item.profileName}`;

						output += '</div>';
					}

					//date
					if (item.dateCreated) {
						output += `<div class="form-label json-output-object-item-value small-size text-truncate ms-3 mb-1">`;
						output += `<span>${moment(item.dateCreated).format('DD-MM-YYYY')}</span>`;
						output += `<span class="ms-3">(${item.timeAgo})</span>`;
						output += '</div>';
					}

					//text
					if (item.questionText) {
						let textForTitle = item.questionText;

						if (shouldHighlightText && selectedKeyword) {
							item.questionText = getHighlightedText(item.questionText, selectedKeyword);
						}

						output += `<div class="json-output-object-item">`;
						output += `<label class="form-label json-output-object-item-value text-truncate w-100" title="${textForTitle}">${item.questionText}</label>`;
						output += '</div>';
					}

					//answers
					if (item.items) {
						output += '<div class="qa-answers-wrapper border-start">';

						item.items.forEach((answer) => {
							//user
							if (answer.profileName) {
								output += `<div class="form-label json-output-object-item-value text-truncate" title="${answer.profileName}">${answer.profileName}</div>`;
							}

							if (answer.timestamp) {
								output += `<div class="form-label json-output-object-item-value small-size text-truncate mb-1">`;
								output += `<span>${moment(answer.timestamp).format('DD-MM-YYYY')}</span>`;
								output += `<span class="ms-3">(${answer.timeAgo})</span>`;
								output += '</div>';
							}

							let textForTitle = answer.answerText;

							if (shouldHighlightText && selectedKeyword) {
								answer.answerText = getHighlightedText(answer.answerText, selectedKeyword);
							}

							output += `<label class="form-label json-output-object-item-value text-truncate w-100" title="${textForTitle}">${answer.answerText}</label>`;
							output += '</div>';
							output += '</div>';
						});

						output += '</div>';
					}

					output += '</div>';
				});
			} else {
				output += '<label class="form-label json-output-object-item-value">No data</label>';
			}
		} else {
			output += '<label class="form-label json-output-object-item-value">No data</label>';
		}

		setJsonOutput(output);
		toggleJsonOutputDialog();

		return output;
	};

	const printWorkHours = (dataIndex) => {
		let output = '';

		let title = 'Business Hours';
		output += `<h4 class="json-output-title mb-3">${title}</h4>`;

		if (
			auditKeywordData &&
			auditKeywordData[dataIndex] &&
			auditKeywordData[dataIndex].profile &&
			auditKeywordData[dataIndex].profile.workTime &&
			auditKeywordData[dataIndex].profile.workTime.data &&
			auditKeywordData[dataIndex].profile.workTime.data.timetable
		) {
			let days = auditKeywordData[dataIndex].profile.workTime.data.timetable;

			if (days) {
				Object.keys(days).map((key, index) => {
					let hoursStr = '';
					output += `<div class="row json-output-array-item mb-1" key="${index}">`;
					output += `<label class="form-label json-output-object-item-label">${capitalize(key)}:</label>`;

					if (days[key] && Array.isArray(days[key]) && days[key].length > 0) {
						let dayObj = days[key][0];

						if (dayObj) {
							if (dayObj.open && dayObj.open.hour !== null) {
								let openStr = dayObj.open.hour;

								if (dayObj.open.minute !== null) {
									openStr += ':' + (parseInt(dayObj.open.minute) === 0 ? '00' : dayObj.open.minute);
								}

								if (openStr) {
									//hoursStr += moment(openStr, [ 'h:mm A' ]).format('HH:mm');
									hoursStr += moment(openStr, 'HH:mm').format('h:mm A');
								}
							}

							if (dayObj.close && dayObj.close.hour !== null) {
								let closeStr = dayObj.close.hour;

								if (dayObj.close.minute !== null) {
									closeStr +=
										':' + (parseInt(dayObj.close.minute) === 0 ? '00' : dayObj.close.minute);
								}

								if (closeStr) {
									hoursStr += ' - ' + moment(closeStr, 'HH:mm').format('h:mm A');
								}
							}
						}
					} else {
						hoursStr = 'Closed';
					}

					output += `<label class="form-label json-output-object-item-value w-auto">${hoursStr}</label>`;
					output += '</div>';
				});
			} else {
				output += '<label class="form-label json-output-object-item-value">No data</label>';
			}
		} else {
			output += '<label class="form-label json-output-object-item-value">No data</label>';
		}

		setJsonOutput(output);
		toggleJsonOutputDialog();

		return output;
	};

	const printCitationsList = (dataIndex, printPropName, shouldHighlightText = false) => {
		let output = '';

		let title = '';
		let prinPropNameArgs = [];

		if (printPropName) {
			prinPropNameArgs = printPropName.indexOf('.') > -1 ? printPropName.split('.') : [ printPropName ];

			if (printPropName.indexOf('powerContent') > -1) {
				title = 'Power Content';
			} else if (printPropName.indexOf('powerCitations') > -1) {
				title = 'Power Citations';
			} else if (printPropName.indexOf('citations') > -1) {
				title = 'Citations';
			} else if (printPropName.indexOf('indexedPages') > -1) {
				title = 'Indexed Pages';
			}
		}

		output += `<h4 class="json-output-title mb-3">${title}</h4>`;

		if (auditKeywordData && auditKeywordData[dataIndex]) {
			let results;

			if (prinPropNameArgs && prinPropNameArgs.length === 2) {
				if (prinPropNameArgs[1] === 'results') {
					results = auditKeywordData[dataIndex][prinPropNameArgs[0]][prinPropNameArgs[1]];
				} else {
					let items = auditKeywordData[dataIndex][prinPropNameArgs[0]].find(
						(x) => x.website.indexOf(prinPropNameArgs[1].replace('__', '.')) > -1
					);

					if (items && items.results) {
						results = items.results;
					}
				}
			}

			if (results && results.length > 0) {
				results.map((item, index) => {
					output += `<div class="json-output-array-item mb-2 py-2 border-bottom" key="${index}">`;

					//title
					if (item.title) {
						if (shouldHighlightText && selectedKeyword) {
							item.title = getHighlightedText(item.title, selectedKeyword);
						}

						output += `<div class="form-label json-output-object-item-value text-truncate">`;
						output += `<span>${index + 1}. </span>${item.title}`;
						output += '</div>';
					}

					//link
					if (item.link) {
						output += `<div class="form-label json-output-object-item-value text-truncate">`;
						output += `<a class="btn btn-link p-0 json-output-object-item-value text-truncate" title="${item.link}" href="${item.link}" target="_blank">${item.link}</a>`;
						output += '</div>';
					}

					output += '</div>';
				});
			} else {
				output += '<label class="form-label json-output-object-item-value">No data</label>';
			}
		} else {
			output += '<label class="form-label json-output-object-item-value">No data</label>';
		}

		setJsonOutput(output);
		toggleJsonOutputDialog();

		return output;
	};

	const toggleJsonOutputDialog = async (e) => {
		setShowJsonOutputDialog(!showJsonOutputDialog);

		if (showJsonOutputDialog) {
			setJsonOutput();
		}

		if (e) e.preventDefault();
	};

	return (
		<div className={`container public-view-audit-report-container-old-v1`}>
			{isLoading ? (
				<div className="text-center">
					<Spinner />
				</div>
			) : (
				<div className={`main-content-inner-container`}>
					{task && (
						<Fragment>
							<div className="header-wrapper">
								<div className="task-details-wrapper">
									<div className="company-name text-start">{task.salesCompanyName}</div>
									<div className="created-date text-start">{`Date: ${moment(task.dateCreated).format(
										'MM/DD/YYYY [@] hh:mm A [EST]'
									)}`}</div>
								</div>

								{gridKeywords &&
								gridKeywords.length > 0 && (
									<div className="grid-keywords-wrapper">
										{gridKeywords.map((keywordName, index) => (
											<button
												className={`btn btn${selectedKeyword && selectedKeyword === keywordName
													? ''
													: '-outline'}-primary me-2`}
												onClick={() => handleSelectKeyword(keywordName)}
												disabled={isLoading}
												key={index}
											>
												{keywordName}
											</button>
										))}
									</div>
								)}
							</div>

							<div className="accordion" id="accordionReport">
								{/* grid */}
								<div className="accordion-item">
									<h2 className="accordion-header">
										<button
											className="accordion-button"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseGrid"
											aria-expanded="true"
											aria-controls="collapseGrid"
										>
											Grid
										</button>
									</h2>
									<div
										id="collapseGrid"
										className="accordion-collapse collapse show"
										data-bs-parent="#accordionReport"
									>
										<div className="accordion-body">
											<div className="show-competition-button-wrapper">
												{isMobile() ? (
													<select
														className="form-select"
														onChange={(e) =>
															handleSelectCompetitorOnMapMobile(e.target.value)}
														value={
															selectedCompetitorOnMap ? (
																selectedCompetitorOnMap.place_id
															) : (
																''
															)
														}
													>
														<option value="">- Competitor -</option>
														{competitorsData &&
														competitorsData.length && (
															<Fragment>
																{competitorsData.map((competitor, index) => (
																	<option value={competitor.place_id} key={index}>
																		{competitor.title}
																	</option>
																))}
															</Fragment>
														)}
													</select>
												) : (
													<button className="btn btn-link" onClick={toggleCompetitorsPanel}>
														{`${showCompetitorsPanel ? 'Hide' : 'Show'} Competitors`}
													</button>
												)}
											</div>

											<div className="public-grid-map-container">
												<Fragment>
													{mapGridData && (
														<GridMapV5
															key="map-0"
															mapIdValue="report-map-0"
															gridData={mapGridData}
															placeId={mapGridData.googlePlaceId}
															isFullHeight={true}
															reportSettings={reportSettings}
															selectedCompetitor={selectedCompetitorOnMap}
														/>
													)}

													{showCompetitorsPanel && (
														<div className="map-competitors-panel">
															{competitorsData &&
															competitorsData.length > 0 && (
																<Fragment>
																	{competitorsData.map((competitor, index) => (
																		<Fragment key={index}>
																			{competitor.place_id && (
																				<div
																					className={`competitor-item ${selectedCompetitorOnMap &&
																					selectedCompetitorOnMap.place_id ===
																						competitor.place_id
																						? 'active'
																						: ''}`}
																					key={index}
																					onClick={() =>
																						handleSelectCompetitorOnMap(
																							competitor
																						)}
																				>
																					<div className="competitor-name">
																						{competitor.title || ''}
																					</div>
																					<div className="competitor-detail">
																						<span className="competitor-label">
																							{competitor.place_id || ''}
																						</span>
																					</div>

																					{competitor.data_cid && (
																						<div className="competitor-detail">
																							{/* <span className="competitor-label">Cid:</span> */}
																							<span className="competitor-label">
																								{competitor.data_cid}
																							</span>
																						</div>
																					)}

																					{competitor.website && (
																						<div className="competitor-detail">
																							{/* <span className="competitor-label">
																							Website:
																						</span> */}
																							<span className="competitor-label">
																								<a
																									className="btn btn-link p-0"
																									href={`https://${competitor.website}`}
																									target="_blank"
																								>
																									{`https://${competitor.website}`}
																								</a>
																							</span>
																						</div>
																					)}
																				</div>
																			)}
																		</Fragment>
																	))}
																</Fragment>
															)}
														</div>
													)}
												</Fragment>
											</div>
										</div>
									</div>
								</div>

								{/* Profile Optimization */}
								<div className="accordion-item">
									<h2 className="accordion-header">
										<button
											className="accordion-button collapsed"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseProfileOptimization"
											aria-expanded="false"
											aria-controls="collapseProfileOptimization"
										>
											Profile Optimization
										</button>
									</h2>
									<div
										id="collapseProfileOptimization"
										className="accordion-collapse collapse"
										data-bs-parent="#accordionReport"
									>
										<div className="accordion-body">
											<div className="summary-data-container">
												{summaryData && (
													<Fragment>
														<div className="row">
															<div className="col-12 col-sm-6">
																<div className="my-2 text-center">
																	Optimization Checklist
																</div>
																<div className="summary-messages-container">
																	{summaryChecklistItems &&
																	summaryChecklistItems.length ? (
																		<Fragment>
																			{summaryChecklistItems.map(
																				(item, index) => (
																					<Fragment key={index}>
																						{item && (
																							<div
																								className="message-item"
																								key={index}
																							>
																								<span className="icon">
																									<i className="fas fa-check" />
																								</span>
																								<span className="ms-2">
																									{item.message}
																								</span>
																							</div>
																						)}
																					</Fragment>
																				)
																			)}
																		</Fragment>
																	) : (
																		<div className="message-item">No items</div>
																	)}
																</div>
															</div>
															<div className="col-12 col-sm-6">
																<div className="my-2 text-center">
																	Competitor Analysis
																</div>
																<div className="summary-messages-container">
																	{summaryCompetitionItems &&
																	summaryCompetitionItems.length ? (
																		<Fragment>
																			{summaryCompetitionItems.map(
																				(item, index) => (
																					<Fragment key={index}>
																						{item && (
																							<div
																								className="message-item"
																								key={index}
																							>
																								<span className="icon">
																									<i className="fas fa-check" />
																								</span>
																								<span className="ms-2">
																									{item.message}
																								</span>
																							</div>
																						)}
																					</Fragment>
																				)
																			)}
																		</Fragment>
																	) : (
																		<div className="message-item">No items</div>
																	)}
																</div>
															</div>
														</div>
													</Fragment>
												)}
											</div>
										</div>
									</div>
								</div>

								{/* Keyword Optimization */}
								<div className="accordion-item">
									<h2 className="accordion-header">
										<button
											className="accordion-button collapsed"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseKeywordOptimization"
											aria-expanded="false"
											aria-controls="collapseKeywordOptimization"
										>
											Keyword Optimization
										</button>
									</h2>
									<div
										id="collapseKeywordOptimization"
										className="accordion-collapse collapse"
										data-bs-parent="#accordionReport"
									>
										<div className="accordion-body">
											<div className="optimization-data-container">
												{summaryData && (
													<div className="row">
														<div className="col-12 col-sm-6">
															<div className="my-2 text-center">
																Optimization Checklist
															</div>
															<div className="summary-messages-container">
																{summaryChecklistItemsByKeyword &&
																summaryChecklistItemsByKeyword.length ? (
																	<Fragment>
																		{summaryChecklistItemsByKeyword.map(
																			(item, index) => (
																				<Fragment key={index}>
																					{item && (
																						<div
																							className="message-item"
																							key={index}
																						>
																							<span className="icon">
																								<i className="fas fa-check" />
																							</span>
																							<span className="ms-2">
																								{item.message}
																							</span>
																						</div>
																					)}
																				</Fragment>
																			)
																		)}
																	</Fragment>
																) : (
																	<div className="message-item">No items</div>
																)}
															</div>
														</div>
														<div className="col-12 col-sm-6">
															<div className="my-2 text-center">Competitor Analysis</div>
															<div className="summary-messages-container">
																{summaryCompetitionItemsByKeyword &&
																summaryCompetitionItemsByKeyword.length ? (
																	<Fragment>
																		{summaryCompetitionItemsByKeyword.map(
																			(item, index) => (
																				<Fragment key={index}>
																					{item && (
																						<div
																							className="message-item"
																							key={index}
																						>
																							<span className="icon">
																								<i className="fas fa-check" />
																							</span>
																							<span className="ms-2">
																								{item.message}
																							</span>
																						</div>
																					)}
																				</Fragment>
																			)
																		)}
																	</Fragment>
																) : (
																	<div className="message-item">No items</div>
																)}
															</div>
														</div>
													</div>
												)}
											</div>
										</div>
									</div>
								</div>

								{/* audit */}
								<div className="accordion-item">
									<h2 className="accordion-header">
										<button
											className="accordion-button collapsed"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseAudit"
											aria-expanded="false"
											aria-controls="collapseAudit"
										>
											Audit
										</button>
									</h2>
									<div
										id="collapseAudit"
										className="accordion-collapse collapse"
										data-bs-parent="#accordionReport"
									>
										<div className="accordion-body">
											<div className="audit-data-container">
												<div className="audit-table-wrapper border">
													{isLoadingAuditData ? (
														<div className="text-center">
															<Spinner />
														</div>
													) : (
														<table className="items-list audit-table table table-responsive">
															<thead>
																<tr>
																	<th scope="col" className="description">
																		Average Grid Rank:
																	</th>
																	<th className="business" scope="col">
																		{businessGridAverageDataByKeyword}
																	</th>
																	<th className="business competitor" scope="col">
																		{competitorsData &&
																		competitorsData.length > 0 && (
																			<span>
																				{competitorsData[0].average || ''}
																			</span>
																		)}
																	</th>
																	<th className="business competitor" scope="col">
																		{competitorsData &&
																		competitorsData.length > 1 && (
																			<span>
																				{competitorsData[1].average || ''}
																			</span>
																		)}
																	</th>
																	<th className="business competitor" scope="col">
																		{competitorsData &&
																		competitorsData.length > 2 && (
																			<span>
																				{competitorsData[2].average || ''}
																			</span>
																		)}
																	</th>
																</tr>
																<tr>
																	<th scope="col" className="description py-0">
																		Description:
																	</th>
																	<th className="business py-0" scope="col">
																		{companyData &&
																		companyData.googleBusinessUrl ? (
																			<a
																				className="btn btn-link p-0"
																				href={companyData.googleBusinessUrl}
																				target="_blank"
																				title={companyData.name || ''}
																			>
																				<span>Your Business</span>
																				<i className="fa-solid fa-arrow-up-right-from-square ms-2" />
																			</a>
																		) : (
																			'Your Business'
																		)}
																	</th>
																	<th
																		className="business competitor py-0"
																		scope="col"
																	>
																		{competitorsData &&
																		competitorsData.length > 0 &&
																		competitorsData[0].data_cid ? (
																			<a
																				className="btn btn-link p-0"
																				href={`https://maps.google.com/?cid=${competitorsData[0]
																					.data_cid}`}
																				target="_blank"
																				title={competitorsData[0].title || ''}
																			>
																				<span>Competitor 1</span>
																				<i className="fa-solid fa-arrow-up-right-from-square ms-2" />
																			</a>
																		) : (
																			'Competitor 1'
																		)}
																	</th>
																	<th
																		className="business competitor py-0"
																		scope="col"
																	>
																		{competitorsData &&
																		competitorsData.length > 1 &&
																		competitorsData[1].data_cid ? (
																			<a
																				className="btn btn-link p-0"
																				href={`https://maps.google.com/?cid=${competitorsData[1]
																					.data_cid}`}
																				target="_blank"
																				title={competitorsData[1].title || ''}
																			>
																				<span>Competitor 2</span>
																				<i className="fa-solid fa-arrow-up-right-from-square ms-2" />
																			</a>
																		) : (
																			'Competitor 2'
																		)}
																	</th>
																	<th
																		className="business competitor py-0"
																		scope="col"
																	>
																		{competitorsData &&
																		competitorsData.length > 2 &&
																		competitorsData[2].data_cid ? (
																			<a
																				className="btn btn-link p-0"
																				href={`https://maps.google.com/?cid=${competitorsData[2]
																					.data_cid}`}
																				target="_blank"
																				title={competitorsData[2].title || ''}
																			>
																				<span>Competitor 3</span>
																				<i className="fa-solid fa-arrow-up-right-from-square ms-2" />
																			</a>
																		) : (
																			'Competitor 3'
																		)}
																	</th>
																</tr>
																<tr>
																	<th scope="col" className="description" />
																	<th className="business-name" scope="col">
																		{companyData && (
																			<span>{companyData.name || ''}</span>
																		)}
																	</th>
																	<th
																		className="business-name competitor"
																		scope="col"
																	>
																		{competitorsData &&
																		competitorsData.length > 0 && (
																			<span>
																				{competitorsData[0].title || ''}
																			</span>
																		)}
																	</th>
																	<th
																		className="business-name competitor"
																		scope="col"
																	>
																		{competitorsData &&
																		competitorsData.length > 1 && (
																			<span>
																				{competitorsData[1].title || ''}
																			</span>
																		)}
																	</th>
																	<th
																		className="business-name competitor"
																		scope="col"
																	>
																		{competitorsData &&
																		competitorsData.length > 2 && (
																			<span>
																				{competitorsData[2].title || ''}
																			</span>
																		)}
																	</th>
																</tr>
															</thead>
															{auditKeywordData && auditKeywordData.length > 0 ? (
																<tbody>
																	{/* Profile Settings */}
																	{settings.map((setting) => (
																		<tr key={setting.label}>
																			<td className="description">
																				{setting.label}
																			</td>
																			{auditKeywordData.map((business, index) => {
																				let propValue =
																					business[setting.propName];

																				return (
																					<td
																						key={index}
																						className={`business ${business ===
																						'business'
																							? ''
																							: 'competitor'}`}
																					>
																						{propValue ? (
																							<Fragment>
																								<button
																									className="btn btn-link p-0 btn-json-output"
																									onClick={() =>
																										printJsonNodeValue(
																											index,
																											setting
																										)}
																								>
																									<span>
																										{isNumber(
																											propValue
																										) ? (
																											propValue
																										) : (
																											'Yes'
																										)}
																									</span>
																								</button>
																							</Fragment>
																						) : (
																							<span className="json-output-no-value">
																								No
																							</span>
																						)}
																					</td>
																				);
																			})}
																		</tr>
																	))}

																	{/* Domain Age */}
																	<tr>
																		<td className="description">Domain Age</td>
																		{auditKeywordData.map((business, index) => {
																			return (
																				<td key={index} className="business">
																					{business.domainAge !== null &&
																					business.domainAge !== '' &&
																					business.domainAge !== -1 ? (
																						`${business.domainAge} ${business.domainAge ===
																						1
																							? 'Year'
																							: 'Years'}`
																					) : (
																						''
																					)}
																				</td>
																			);
																		})}
																	</tr>

																	{/* Total Indexed Pages */}
																	<tr>
																		<td className="description">
																			Total Indexed Pages
																		</td>
																		{auditKeywordData.map((business, index) => {
																			let printSetting = {
																				label         : 'Indexed Pages',
																				propName      : 'totalIndexedPages',
																				printPropName : 'indexedPages.results'
																			};

																			return (
																				<td
																					key={index}
																					className={`business ${business ===
																					'business'
																						? ''
																						: 'competitor'}`}
																				>
																					{business.totalIndexedPages ? (
																						<button
																							className="btn btn-link p-0 btn-json-output"
																							title={
																								business.totalIndexedPages
																							}
																							onClick={() =>
																								printJsonNodeValue(
																									index,
																									printSetting
																								)}
																						>
																							<span>
																								{
																									business.totalIndexedPages
																								}
																							</span>
																						</button>
																					) : (
																						<span className="json-output-no-value">
																							0
																						</span>
																					)}
																				</td>
																			);
																		})}
																	</tr>

																	{/* Backlinks */}
																	<tr>
																		<td className="description">Backlinks</td>
																		{auditKeywordData.map((business, index) => (
																			<td
																				key={index}
																				className={`business ${business ===
																				'business'
																					? ''
																					: 'competitor'}`}
																			>
																				{business.totalBacklinks ? (
																					<button
																						className="btn btn-link p-0 btn-json-output"
																						title={business.totalBacklinks}
																					>
																						<span>
																							{business.totalBacklinks}
																						</span>
																					</button>
																				) : (
																					<span className="json-output-no-value">
																						0
																					</span>
																				)}
																			</td>
																		))}
																	</tr>

																	{/* Total Citations */}
																	<tr>
																		<td className="description">Total Citations</td>
																		{auditKeywordData.map((business, index) => {
																			let printSetting = {
																				label         : 'Citations',
																				propName      : 'totalCitations',
																				printPropName : 'citations.results'
																			};

																			return (
																				<td
																					key={index}
																					className={`business ${business ===
																					'business'
																						? ''
																						: 'competitor'}`}
																				>
																					{business.totalCitations ? (
																						<Fragment>
																							<button
																								className="btn btn-link p-0 btn-json-output"
																								onClick={() =>
																									printJsonNodeValue(
																										index,
																										printSetting
																									)}
																							>
																								<span>
																									{
																										business.totalCitations
																									}
																								</span>
																							</button>
																						</Fragment>
																					) : (
																						<span className="json-output-no-value">
																							0
																						</span>
																					)}
																				</td>
																			);
																		})}
																	</tr>

																	<tr>
																		<td colSpan={5} className="separator-row">
																			<strong>Keywords In:</strong>
																		</td>
																	</tr>

																	{/* Keywords In Settings */}
																	{kwSettings.map((setting) => (
																		<tr key={setting.label}>
																			<td className="description">
																				{setting.label}
																			</td>
																			{auditKeywordData.map((business, index) => {
																				let propValue =
																					business[setting.propName];
																				let hoverPropValue = business.keywordsIn
																					? business.keywordsIn[
																							setting.hoverPropName
																						]
																					: '';

																				return (
																					<td
																						key={index}
																						className={`business ${business ===
																						'business'
																							? ''
																							: 'competitor'}`}
																					>
																						{propValue ? (
																							<button
																								className="btn btn-link p-0 btn-json-output"
																								title={hoverPropValue}
																								onClick={() =>
																									printJsonNodeValue(
																										index,
																										setting
																									)}
																							>
																								<span>
																									{isNumber(
																										propValue
																									) ? (
																										propValue
																									) : (
																										'Yes'
																									)}
																								</span>
																							</button>
																						) : (
																							<button
																								className="btn btn-link p-0 btn-json-output"
																								title={hoverPropValue}
																								onClick={() =>
																									printJsonNodeValue(
																										index,
																										setting
																									)}
																							>
																								<span className="json-output-no-value">
																									{isNumber(
																										propValue
																									) ? (
																										0
																									) : (
																										'No'
																									)}
																								</span>
																							</button>
																						)}
																					</td>
																				);
																			})}
																		</tr>
																	))}

																	{/* Power Content */}
																	{auditKeywordData[0] &&
																	auditKeywordData[0].powerContent &&
																	auditKeywordData[0].powerContent.length > 0 && (
																		<Fragment>
																			<tr>
																				<td
																					colSpan={5}
																					className="separator-row"
																				>
																					Power Content
																				</td>
																			</tr>
																			{auditKeywordData[0].powerContent.map(
																				(pc, pcIndex) => {
																					let websiteSlug = pc.website
																						.replace('https://', '')
																						.replace('www.', '')
																						.replace('.', '__');
																					let websiteHost = pc.website
																						.replace('https://', '')
																						.replace('www.', '');

																					return (
																						<tr key={pcIndex}>
																							<td className="description">
																								{websiteHost}
																							</td>
																							{auditKeywordData.map(
																								(business, index) => {
																									let pcValue = business.totalPowerContent
																										? business
																												.totalPowerContent[
																												websiteHost
																											]
																										: false;
																									let printSetting = {
																										label         :
																											'Power Content',
																										propName      :
																											pc.website,
																										printPropName : `powerContent.${websiteSlug}`
																									};

																									return (
																										<td
																											key={index}
																											className={`business ${business ===
																											'business'
																												? ''
																												: 'competitor'}`}
																										>
																											{pcValue ? (
																												<Fragment
																												>
																													<button
																														className="btn btn-link p-0 btn-json-output"
																														onClick={() =>
																															printJsonNodeValue(
																																index,
																																printSetting
																															)}
																													>
																														<span
																														>
																															Yes
																														</span>
																													</button>
																												</Fragment>
																											) : (
																												<span className="json-output-no-value">
																													No
																												</span>
																											)}
																										</td>
																									);
																								}
																							)}
																						</tr>
																					);
																				}
																			)}
																		</Fragment>
																	)}

																	<tr>
																		<td
																			className="border border-secondary border-2 p-0"
																			colSpan={5}
																		/>
																	</tr>

																	{/* Power Citations */}
																	{auditKeywordData[0] &&
																	auditKeywordData[0].powerCitations &&
																	auditKeywordData[0].powerCitations.length > 0 && (
																		<Fragment>
																			<tr>
																				<td
																					colSpan={5}
																					className="separator-row"
																				>
																					Power Citations
																				</td>
																			</tr>
																			{auditKeywordData[0].powerCitations.map(
																				(pc, pcIndex) => {
																					let websiteSlug = pc.website
																						.replace('https://', '')
																						.replace('www.', '')
																						.replace('.', '__');

																					return (
																						<tr key={pcIndex}>
																							<td className="description">
																								{pc.website.replace(
																									'https://',
																									''
																								)}
																							</td>
																							{auditKeywordData.map(
																								(business, index) => {
																									let pcItem =
																										business.powerCitations &&
																										business
																											.powerCitations
																											.length > 0
																											? business.powerCitations.find(
																													(x) =>
																														x.website ===
																														pc.website
																												)
																											: null;
																									let printSetting = {
																										label         :
																											'Power Citations',
																										propName      :
																											pc.website,
																										printPropName : `powerCitations.${websiteSlug}`
																									};

																									return (
																										<td
																											key={index}
																											className={`business ${business ===
																											'business'
																												? ''
																												: 'competitor'}`}
																										>
																											{pcItem &&
																											pcItem.total ? (
																												<Fragment
																												>
																													<button
																														className="btn btn-link p-0 btn-json-output"
																														title={
																															pcItem.total
																														}
																														onClick={() =>
																															printJsonNodeValue(
																																index,
																																printSetting
																															)}
																													>
																														<span
																														>
																															Yes
																														</span>
																													</button>
																												</Fragment>
																											) : (
																												<span className="json-output-no-value">
																													No
																												</span>
																											)}
																										</td>
																									);
																								}
																							)}
																						</tr>
																					);
																				}
																			)}
																		</Fragment>
																	)}

																	<tr>
																		<td
																			className="border border-secondary border-2 p-0"
																			colSpan={5}
																		/>
																	</tr>

																	{/* Review Score */}
																	<tr>
																		<td className="separator-row">Review Score</td>
																		{auditKeywordData.map((business, index) => (
																			<td key={index} className="separator-row" />
																		))}
																	</tr>

																	{/* Total Reviews */}
																	<tr>
																		<td className="description">Total Reviews</td>
																		{auditKeywordData.map((business, index) => (
																			<td key={index} className="business">
																				{business.totalReviews ? (
																					<button
																						className="btn btn-link p-0 btn-json-output"
																						title={business.totalReviews}
																						onClick={() =>
																							printReviewsList(
																								index,
																								'total'
																							)}
																					>
																						<span>
																							{business.totalReviews}
																						</span>
																					</button>
																				) : (
																					<span className="json-output-no-value">
																						0
																					</span>
																				)}
																			</td>
																		))}
																	</tr>

																	{/* Average Rating */}
																	<tr>
																		<td className="description">Average Rating</td>
																		{auditKeywordData.map((business, index) => (
																			<td key={index} className="business">
																				{business.averageRating ? (
																					<button
																						className="btn btn-link p-0 btn-json-output"
																						title={business.averageRating}
																						onClick={() =>
																							printReviewsList(
																								index,
																								'total'
																							)}
																					>
																						<span>
																							{business.averageRating}
																						</span>
																					</button>
																				) : (
																					<span className="json-output-no-value">
																						0
																					</span>
																				)}
																			</td>
																		))}
																	</tr>

																	{/* Reviews Last 30 Days */}
																	<tr>
																		<td colSpan={5} className="separator-row">
																			<strong>Last 30 Days</strong>
																		</td>
																	</tr>
																	{reviewsLast30DaysSettings.map((setting) => (
																		<tr key={setting.label}>
																			<td className="description">
																				{setting.label}
																			</td>
																			{auditKeywordData.map((business, index) => {
																				let propValue =
																					business[setting.propName];

																				if (
																					typeof propValue == 'number' &&
																					!isNaN(propValue) &&
																					!Number.isInteger(propValue)
																				) {
																					propValue = parseFloat(
																						propValue
																					).toFixed(1);
																				}

																				return (
																					<td
																						key={index}
																						className={`business ${business ===
																						'business'
																							? ''
																							: 'competitor'}`}
																					>
																						{propValue ? (
																							<button
																								className="btn btn-link p-0 btn-json-output"
																								onClick={() =>
																									printReviewsList(
																										index,
																										'last30Days',
																										setting.propName
																									)}
																							>
																								<span>{propValue}</span>
																							</button>
																						) : (
																							<span className="json-output-no-value">
																								0
																							</span>
																						)}
																					</td>
																				);
																			})}
																		</tr>
																	))}

																	{/* Last 20 Reviews */}
																	<tr>
																		<td colSpan={5} className="separator-row">
																			<strong>Last 20 Reviews</strong>
																		</td>
																	</tr>
																	{reviewsLast20Settings.map((setting) => (
																		<tr key={setting.label}>
																			<td className="description">
																				{setting.label}
																			</td>
																			{auditKeywordData.map((business, index) => {
																				let propValue =
																					business[setting.propName];

																				if (
																					typeof propValue == 'number' &&
																					!isNaN(propValue) &&
																					!Number.isInteger(propValue)
																				) {
																					propValue = parseFloat(
																						propValue
																					).toFixed(1);
																				}

																				return (
																					<td
																						key={index}
																						className={`business ${business ===
																						'business'
																							? ''
																							: 'competitor'}`}
																					>
																						{propValue ? (
																							<button
																								className="btn btn-link p-0 btn-json-output"
																								onClick={() =>
																									printReviewsList(
																										index,
																										'last20',
																										setting.propName
																									)}
																							>
																								<span>{propValue}</span>
																							</button>
																						) : (
																							<span className="json-output-no-value">
																								0
																							</span>
																						)}
																					</td>
																				);
																			})}
																		</tr>
																	))}

																	{/* Most Relevant Review Age */}
																	<tr>
																		<td className="description">
																			Most Relevant Review Age (Sort By Most
																			Relevant)
																		</td>
																		{auditKeywordData.map((business, index) => {
																			return (
																				<td
																					key={index}
																					className={`business ${business ===
																					'business'
																						? ''
																						: 'competitor'}`}
																				>
																					{business.mostRelevantReviewAge ? (
																						<button
																							className="btn btn-link p-0 btn-json-output"
																							onClick={() =>
																								printReviewsList(
																									index,
																									'mostRelevant'
																								)}
																						>
																							<span>
																								{business.mostRelevantReviewAge.replace(
																									' ago',
																									''
																								)}
																							</span>
																						</button>
																					) : (
																						''
																					)}
																				</td>
																			);
																		})}
																	</tr>
																</tbody>
															) : (
																<tbody>
																	<tr>
																		<td colSpan={5}>
																			<i>No Data</i>
																		</td>
																	</tr>
																</tbody>
															)}
														</table>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</Fragment>
					)}

					{showJsonOutputDialog && (
						<ModalDialog className="text-start" position="right-sidebar">
							<ModalDialogContent align="start">
								<div className="json-output-container">
									<div className="row" dangerouslySetInnerHTML={{ __html: jsonOutput }} />
								</div>
							</ModalDialogContent>
							<ModalDialogButtons>
								<div className="row">
									<div className="text-start col-12">
										<button className="btn btn-outline-primary" onClick={toggleJsonOutputDialog}>
											<span>Close</span>
										</button>
									</div>
								</div>
							</ModalDialogButtons>
						</ModalDialog>
					)}
				</div>
			)}
		</div>
	);
};

export default AuditReportPublicView_OLD_V1;
